module.exports = __webpack_public_path__ + "static/media/main-screen-card-about-us.4327bbdb.png";